import { render, staticRenderFns } from "./Measure.vue?vue&type=template&id=2a3cca38&scoped=true&"
import script from "./Measure.vue?vue&type=script&lang=js&"
export * from "./Measure.vue?vue&type=script&lang=js&"
import style0 from "./Measure.vue?vue&type=style&index=0&id=2a3cca38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3cca38",
  null
  
)

export default component.exports